import { type KeyboardEvent, type TouchEvent, useRef, useState } from 'react'

export function useFeatureCarousel(count: number) {
  const [index, setIndex] = useState(0)
  const touchStart = useRef<{ x: number; y: number } | null>(null)
  const select = (next: number) => setIndex(Math.max(0, Math.min(count - 1, next)))
  const onKeyDown = (event: KeyboardEvent<HTMLElement>) => {
    if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return
    const destinations: Record<string, number> = {
      ArrowLeft: index - 1,
      ArrowRight: index + 1,
      Home: 0,
      End: count - 1,
    }
    const next = destinations[event.key]
    if (next === undefined) return
    event.preventDefault()
    select(next)
  }
  const onTouchStart = (event: TouchEvent) => {
    const touch = event.touches[0]
    touchStart.current = event.touches.length === 1 ? { x: touch.clientX, y: touch.clientY } : null
  }
  const onTouchEnd = (event: TouchEvent) => {
    const start = touchStart.current
    touchStart.current = null
    if (!start || event.changedTouches.length !== 1) return
    const touch = event.changedTouches[0]
    const dx = touch.clientX - start.x
    const dy = touch.clientY - start.y
    // Let vertical scrolling and small taps pass through unchanged.
    if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) select(index + (dx < 0 ? 1 : -1))
  }
  const onTouchCancel = () => {
    touchStart.current = null
  }
  return { index, select, onKeyDown, onTouchStart, onTouchEnd, onTouchCancel }
}
